import apiClient from '@/lib/api';
import type { CfCode } from '@/types';

export async function listCfCodes(includeInactive = false): Promise<CfCode[]> {
  const { data } = await apiClient.get('/cf-codes', {
    params: includeInactive ? { includeInactive: true } : {},
  });
  return data.data ?? data;
}

export async function createCfCode(
  payload: Omit<CfCode, 'id' | 'createdAt' | 'updatedAt'>,
): Promise<CfCode> {
  const { data } = await apiClient.post('/cf-codes', payload);
  return data.data ?? data;
}

export async function updateCfCode(
  id: string,
  payload: Partial<Omit<CfCode, 'id' | 'createdAt' | 'updatedAt'>>,
): Promise<CfCode> {
  const { data } = await apiClient.patch(`/cf-codes/${id}`, payload);
  return data.data ?? data;
}

export async function deactivateCfCode(id: string): Promise<CfCode> {
  const { data } = await apiClient.patch(`/cf-codes/${id}`, { isActive: false });
  return data.data ?? data;
}

// ── Qlik report-mapping check ─────────────────────────────────────────────────
export interface MappingStatus {
  capturedAt: string | null;
  mappedCount: number;
  mapped: Record<string, string>; // code → Qlik report row
  unmapped: Array<{ id: string; code: string; label: string }>;
  exposure: {
    lines: number;
    absPence: string;
    byCode: Array<{ code: string; lines: number; absPence: string }>;
  };
}

export async function getMappingStatus(): Promise<MappingStatus> {
  const { data } = await apiClient.get('/cf-codes/mapping-status');
  return data;
}

export async function refreshMappingStatus(): Promise<MappingStatus> {
  const { data } = await apiClient.post('/cf-codes/mapping-status/refresh');
  return data.status;
}
